import { gql } from '@apollo/client';
import { NSC_SUBJECT_DATA } from '../fragments';

export const FILTERED_NSC_SUBJECTS = gql`
  query FilteredNSCSubjects($input: SearchData!) {
    subjects: filteredNSCSubjectDatas(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          ...nscSubjectData
        }
      }
    }
  }
  ${NSC_SUBJECT_DATA}
`;
